import {NodeData} from './node-data';
import {TreeNode} from './tree-node';

function itemHasChildren(item: NodeData): item is (NodeData & { children: NodeData[]; }) {
  return item.children !== undefined && item.children.length > 0;
}

/******************************************************************************/

function isLeafNode(node: TreeNode): boolean {
  return node.children.length === 0;
}

function forEachNode(nodes: TreeNode[], action: (node: TreeNode) => void) {
  for (let node of nodes) {
    action(node);
    if (isLeafNode(node))
      continue;
    forEachNode(node.children, action);
  }
}

function forEachNodeUp(node: TreeNode, action: (node: TreeNode) => void) {
  if (node.parent === null)
    return;
  action(node);
  forEachNodeUp(node.parent, action);
}

function expandAll(nodes: TreeNode[]) {
  forEachNode(nodes, node => node.expand());
}

function expandAllUp(node: TreeNode) {
  forEachNodeUp(node, node => node.expand());
}

function makeNodeByRoute(nodes: TreeNode[]): { [index: string]: TreeNode } {
  const result: { [index: string]: TreeNode } = {};
  forEachNode(nodes, node => result[node.data.route] = node);
  return result;
}

function findExpandedNodes(nodes: TreeNode[]): string[] {
  const result: string[] = [];
  forEachNode(nodes, node => {
    if (node.expanded)
      result.push(node.data.route);
  });
  return result;
}

/******************************************************************************/

function link(parent: TreeNode, child: TreeNode) {
  child.parent = parent;
  parent.children.push(child);
}

function makeNode(item: NodeData): TreeNode {
  return new TreeNode(null, item);
}

function makeNodeDesc(item: NodeData): TreeNode {
  let result = makeNode(item);

  if (itemHasChildren(item))
    for (let childItem of item.children) {
      let child = makeNodeDesc(childItem);
      link(result, child);
    }

  return result;
}

function makeRoot(nodes: NodeData[]): TreeNode {
  let newRootItem: NodeData = {
    label: 'tree-service-root',
    route: 'tree-service-root',
    children: nodes,
  };
  return makeNodeDesc(newRootItem);
}

class TreeUtilsClass {
  makeRoot = makeRoot;
  makeNodeByRoute = makeNodeByRoute;
  expandAll = expandAll;
  expandAllUp = expandAllUp;
  findExpandedNodes = findExpandedNodes;
}

export const TreeUtils = new TreeUtilsClass();

